// extracted by mini-css-extract-plugin
export var brand = "_57-9";
export var compact = "_57-6";
export var extraSmall = "_57-7";
export var icon = "_57-0";
export var large = "_57-4";
export var light = "_57-1";
export var medium = "_57-5";
export var outline = "_57-b";
export var primaryDark = "_57-a";
export var primaryLight = "_57-8";
export var primaryModern = "_57-c";
export var success = "_57-2";
export var successSolid = "_57-3";